import type { ReactElement, ReactNode } from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

type LabelledElement = ReactElement<{ 'aria-label'?: string }>;

/**
 * Shows an icon-only control's name on hover and focus. DESIGN.md gives every
 * icon-only button an `aria-label`; this is its visible twin, so sighted
 * users get the same name a screen reader does. The label is the child's own
 * `aria-label` unless `label` says otherwise (a menu trigger wrapping the
 * button, for instance).
 */
export function IconTooltip({
  children,
  label,
}: {
  children: LabelledElement;
  label?: ReactNode;
}) {
  const text = label ?? children.props['aria-label'];
  if (!text) return children;
  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent>{text}</TooltipContent>
    </Tooltip>
  );
}
